var IS_PURE = require('../internals/is-pure');
var getIterator = require('../internals/get-iterator');

module.exports = IS_PURE ? getIterator : function (it) {
  // eslint-disable-next-line no-undef
  return Set.prototype.values.call(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/get-set-iterator.js
// module id = 150
// module chunks = 0